import { takeEvery, put, call, Effect, select } from "redux-saga/effects";
import { FormsService } from "../../../services/forms";
import { getHubspotTablesFailure, getHubspotTablesSuccess } from "../../auth/actionCreators";
import { AuthActionTypes, GetHubspotTablesRequestActionType } from "../../auth/types";

function* getHubspotTablesSaga(action: GetHubspotTablesRequestActionType): Generator<Effect, void, any> {
    try {
        const { table } = action.payload;
        const formId: string = yield select(state => state.forms.current._id);
        const response = yield call(() => FormsService.getHubspotTables(formId, { table }));
        if (response.data.success) {
            yield put(getHubspotTablesSuccess(response.data));
        } else {
            yield put(getHubspotTablesFailure(response.message || "Failed to get hubspot tables config"));
        }
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to get hubspot tables";
        console.error("Error getting hubspot tables:", error);
        yield put(getHubspotTablesFailure(errorMessage));
    }
}
export function* watchGetHubspotProperty() {
    yield takeEvery<GetHubspotTablesRequestActionType>(
        AuthActionTypes.GET_HUBSPOT_TABLES_REQUEST,
        getHubspotTablesSaga,
    );
}
